class ImgSrcCollector extends HTMLElement {
  constructor() {
    super();
    this.imgSrcArray = [];
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.collectImageSources();
    this.populateMegamenuImages();
  }

  collectImageSources() {
    this.imgSrcArray = [];
    // Collect images inside <img-src-collector> elements
    const collectors = document.querySelectorAll('img-src-collector');

    collectors.forEach(collector => {
      const img = collector.querySelector('img[src]');
      if (img && img.src.trim() !== '') {
        this.imgSrcArray.push({
          src: img.src,
          alt: img.alt || '',
          dataMenuLink: img.getAttribute('data-menu-link') || '',
          discountText: img.getAttribute('data-discount-text') || '',
          showDiscount: img.getAttribute('data-show-discount') === 'true'
        });
      }
    });
  }

   populateMegamenuImages() {
  const megamenuLinks = document.querySelectorAll('.nav-megamenu_heading');

  megamenuLinks.forEach(link => {
    const img = link.querySelector('img.desktop-header-images');
    const discountWrapper = link.querySelector('.discount-badge-wrap');
    const discountTextSpan = link.querySelector('.discount-badge-text');
    
    if (img) {
      const altText = img.alt.toLowerCase();
      const matchedImage = this.imgSrcArray.find(item =>
        item.alt.toLowerCase() === altText ||
        item.dataMenuLink.toLowerCase() === altText
      );

      if (matchedImage) {
        // Set the main image
        img.src = matchedImage.src || '';
        
        // Handle discount badge
        if (discountWrapper && discountTextSpan) {
          if (matchedImage.showDiscount && matchedImage.discountText) {
            discountTextSpan.textContent = matchedImage.discountText;
            discountWrapper.style.display = 'inline-block';
          } else {
            discountWrapper.style.display = 'none';
          }
        }
      }

      // Handle image loading and errors
      if (!img.src || img.src.trim() === '' || img.src.includes('Liquid error')) {
        img.classList.add('hidden');
      } else {
        // Setup event to hide image on load error
        img.onload = function() {
          if (img.naturalWidth === 0) {
            img.classList.add('hidden');
          } else {
            img.classList.remove('hidden');
          }
        };
        // Also set error event to hide if it fails to load
        img.onerror = function() {
          img.classList.add('hidden');
        };
        // Trigger onload manually if image already cached
        if (img.complete) {
          if (img.naturalWidth === 0) {
            img.classList.add('hidden');
          } else {
            img.classList.remove('hidden');
          }
        }
      }
    }
  });
}


  getImageSources() {
    return this.imgSrcArray;
  }

  repopulate() {
    this.imgSrcArray = [];
    this.init();
  }
}

customElements.define('img-src-collector', ImgSrcCollector);
